import { t } from 'i18next';
import routes from '../../../../Routes/routes';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { CleanIcon, EditIcon, IconInfoCard, IconTextPencil } from '../../../../components/buttons/IconButtons';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import { CustomTextField } from '../../../../components/CustomTextField';
import { permissionObj } from '../../../../Helpers/permission';
import AddUpdateHeadersApp from './Functionality/AddUpdateHeadersApp';
import CustomCard from '../../../../components/CustomCard';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import CustomUserChip from '../../../../components/CustomUserChip';
import { Trans } from 'react-i18next';
import DivContainerBody from './../../../../components/DivContainerBody';

const AddUpdateHeaders = () => {
    const {
        handleChange,
        handleHeaders,
        handleClearFields,
        navigate,
        DEV,
        permission,
        headerObj,
        contractorId,
        supplierId,
    } = AddUpdateHeadersApp();

    if (contractorId !== null || supplierId !== null) navigate(routes.forbidden);
    else if (!DEV && !permission?.includes(permissionObj?.WEB_HEADERS_UPDATE)) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'custom_headers'}
                link={routes.employee.list}
                divStack={
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_auh_clean_form'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        onClick={() => {
                            handleClearFields();
                        }}
                    />
                }
            >
                <ButtonAction
                    id='btn_auh_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handleHeaders();
                    }}
                />
            </HeadTittle>
            <DivContainerBody>
           
                    <div className='col-12 mb-3 px-0 '>
                        <CustomUserChip
                            className=' col-12  chip-secondary-150-100'
                            name={
                                <Trans
                                    i18nKey='custom_fields_control_text_full'
                                    components={{ bold: <span className='ibl-font-w-700' /> }}
                                />
                            }
                            showAvatar={true}
                            Icon={IconInfoCard}
                            iconPosition={POSITION_MODEL.LEFT}
                            classNameIcon='icon-color-secondary-700'
                        />
                    </div>
                    <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                        <div className={'d-flex align-items-center m-3'}>
                            <IconTextPencil />
                            <p className={'font-color-general-950 fs-16px ml-2 ibl-font-w-600'}>{t('other_details')}</p>
                        </div>
                        <div className='pb-3'>
                            <div className={'border-bottom-shades-300'} />
                        </div>
                        <div className='row pt-3'>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header1'}
                                    length={128}
                                    name={'header1'}
                                    value={headerObj?.header1}
                                    trans={t('header_1')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header2'}
                                    length={128}
                                    name={'header2'}
                                    value={headerObj?.header2}
                                    trans={t('header_2')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header3'}
                                    length={128}
                                    name={'header3'}
                                    value={headerObj?.header3}
                                    trans={t('header_3')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header4'}
                                    length={128}
                                    name={'header4'}
                                    value={headerObj?.header4}
                                    trans={t('header_4')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header5'}
                                    length={128}
                                    name={'header5'}
                                    value={headerObj?.header5}
                                    trans={t('header_5')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header6'}
                                    length={128}
                                    name={'header6'}
                                    value={headerObj?.header6}
                                    trans={t('header_6')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header7'}
                                    length={128}
                                    name={'header7'}
                                    value={headerObj?.header7}
                                    trans={t('header_7')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header8'}
                                    length={128}
                                    name={'header8'}
                                    value={headerObj?.header8}
                                    trans={t('header_8')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header9'}
                                    length={128}
                                    name={'header9'}
                                    value={headerObj?.header9}
                                    trans={t('header_9')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header10'}
                                    length={128}
                                    name={'header10'}
                                    value={headerObj?.header10}
                                    trans={t('header_10')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header11'}
                                    length={128}
                                    name={'header11'}
                                    value={headerObj?.header11}
                                    trans={t('header_11')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header12'}
                                    length={128}
                                    name={'header12'}
                                    value={headerObj?.header12}
                                    trans={t('header_12')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header13'}
                                    length={128}
                                    name={'header13'}
                                    value={headerObj?.header13}
                                    trans={t('header_13')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header14'}
                                    length={128}
                                    name={'header14'}
                                    value={headerObj?.header14}
                                    trans={t('header_14')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='col-sm-12 col-lg-6 col-xxl-6'>
                                <CustomTextField
                                    id={'txt_auh_header15'}
                                    length={128}
                                    name={'header15'}
                                    value={headerObj?.header15}
                                    trans={t('header_15')}
                                    type={'text'}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </CustomCard>
               
            </DivContainerBody>
        </>
    );
};

export default AddUpdateHeaders;
